import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MembershipStatus } from '../../data-space/services/federator-onboarding.service';
import { Certificate } from '../models/certificate';
import { catchError, map, switchMap } from 'rxjs/operators';
import { HttpHelperService } from 'src/app/construct-x/shared/services/http-helper';


@Injectable({
  providedIn: 'root'
})
export class CertificateService {

  constructor(private http: HttpClient, private httpHelper: HttpHelperService) { }

  getCertificates(ownerId: number): Observable<{ message: string, status: number, value: Certificate[] }> {
    return this.http.get<Certificate[]>(environment.server.endpoints.wallet.certificates+"/"+ownerId, { withCredentials: true }).pipe(
      map((certificates) => {
        return {
          message: "success",
          status: 200,
          value: certificates.map((certificate) => Certificate.fromHttp(certificate))
        }
      }),
      catchError((error) => {
        return of({ message: error.message, status: error.status, value: [] });
      })
    );
  }

  getMembership(ownerId: number): Observable<{ status: MembershipStatus | null; credential: any }> {
    const base = `/proxy/api/v0/userservice/organisations/${ownerId}/onboarding`;
    // Refresh first: acceptance and credential retrieval are separate steps.
    return this.http.get<MembershipStatus | null>(base).pipe(
      switchMap(status => status?.credentialStatus === 'STORED'
        ? this.http.get(`${base}/credential`).pipe(map(credential => ({ status, credential })))
        : of({ status, credential: null }))
    );
  }

  showInOrgCard(certificateId: number, show: boolean): Observable<{ message: string, status: number, value: string }> {
    let params = this.httpHelper.buildHttpParams(['certificateId', 'show'], [certificateId+"", show+""]);
    return this.http.put(environment.server.endpoints.wallet.show, null, { params: params, withCredentials: true, responseType: 'text' }).pipe(
      map(() => ({ message: "success", status: 200, value: "" })),
      catchError((error) => {
        return of({ message: error.message, status: error.status, value: "" });
      })
    );
  }

  deleteCertificate(certificateId: number): Observable<{ message: string, status: number, value: string }> {
    return this.http.delete(environment.server.endpoints.wallet.certificates+"/"+certificateId, { withCredentials: true, responseType: 'text' }).pipe(
      map(() => ({ message: "success", status: 200, value: "" })),
      catchError((error) => {
        return of({ message: error.message, status: error.status, value: "" });
      })
    );
  }
}
